import React, { useState } from "react";

interface VaultActionBarProps {
  statement: string;
  buttonLabel: string;
  requiresConfirmation?: boolean;
  confirmWord?: string;
  onAction: () => Promise<void>;
  loading?: boolean;
  completed?: boolean;
  completedLabel?: string;
  onToggleComments?: () => void;
  commentsOpen?: boolean;
}

export const VaultActionBar: React.FC<VaultActionBarProps> = ({
  statement,
  buttonLabel,
  requiresConfirmation = false,
  confirmWord = "accetto",
  onAction,
  loading = false,
  completed = false,
  completedLabel = "Accepted",
  onToggleComments,
  commentsOpen = false,
}) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [confirmText, setConfirmText] = useState("");

  const isConfirmed =
    confirmText.toLowerCase().trim() === confirmWord.toLowerCase();

  const handleClick = () => {
    if (completed || loading) return;
    if (requiresConfirmation) {
      setModalOpen(true);
    } else {
      onAction();
    }
  };

  const handleConfirm = async () => {
    if (!isConfirmed) return;
    setModalOpen(false);
    setConfirmText("");
    await onAction();
  };

  const commentButton = onToggleComments ? (
    <button
      className="vault-btn"
      onClick={onToggleComments}
      style={{
        minWidth: 140,
        background: commentsOpen ? "var(--vault-fg-black)" : "transparent",
        color: commentsOpen ? "#fff" : "var(--vault-fg-black)",
      }}
    >
      <span>&#9993; Commenti</span>
    </button>
  ) : null;

  if (completed) {
    return (
      <div className="vault-action-bar vault-zone-accepted">
        <div className="vault-action-statement">
          <span className="vault-completed-badge">
            [ &#10003; ] {completedLabel}
          </span>
        </div>
        <div style={{ display: "flex", gap: "var(--vault-spacing-sm)" }}>
          {commentButton}
        </div>
      </div>
    );
  }

  return (
    <>
      <div className={`vault-action-bar ${requiresConfirmation ? "vault-zone-pending" : ""}`}>
        <div className="vault-action-statement">{statement}</div>
        <div style={{ display: "flex", gap: "var(--vault-spacing-sm)", alignItems: "center" }}>
          {commentButton}
          <button
            className="vault-btn"
            onClick={handleClick}
            disabled={loading}
          >
            <span>{loading ? "Processing..." : buttonLabel}</span>
            <span className="vault-btn-arrow">&#8599;</span>
          </button>
        </div>
      </div>

      {modalOpen && (
        <div
          className="vault-modal-overlay"
          onClick={() => {
            setModalOpen(false);
            setConfirmText("");
          }}
        >
          <div className="vault-modal" onClick={(e) => e.stopPropagation()}>
            <div className="vault-modal-title">Conferma accettazione</div>
            <p>
              Stai per accettare questa policy. Questa azione viene registrata.
            </p>
            <p>
              Scrivi <strong>{confirmWord}</strong> per confermare:
            </p>
            <input
              className="vault-modal-input"
              value={confirmText}
              onChange={(e) => setConfirmText(e.target.value)}
              placeholder={confirmWord}
              onKeyDown={(e) => e.key === "Enter" && handleConfirm()}
              autoFocus
            />
            <div className="vault-modal-actions">
              <button
                className="vault-btn-ghost"
                onClick={() => {
                  setModalOpen(false);
                  setConfirmText("");
                }}
              >
                Annulla
              </button>
              <button
                className="vault-btn"
                onClick={handleConfirm}
                disabled={!isConfirmed}
                style={{ minWidth: 140 }}
              >
                <span>Conferma</span>
                <span className="vault-btn-arrow">&#8599;</span>
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
